/* global axios */
import ApiClient from './ApiClient';

// NOTICE: KAPTION-INTEGRATION
// Kaption2FA (WhatsApp second factor) enrollment. Profile-scoped — see
// Api::V1::Profile::KaptionWhatsapp2faController. MCP binding lives in
// kaptionMcpGrant.js.
class KaptionWhatsapp2faAPI extends ApiClient {
  constructor() {
    super('profile/kaption_whatsapp2fa', { accountScoped: false });
  }

  getStatus() {
    return axios.get(this.url);
  }

  // Also used to resend — the server enforces a 60s cooldown.
  sendCode(phone) {
    return axios.post(this.url, { phone });
  }

  verify(code) {
    return axios.post(`${this.url}/verify`, { code });
  }

  disable(password) {
    return axios.delete(this.url, { data: { password } });
  }
}

export default new KaptionWhatsapp2faAPI();
